
let constGlobal = {};
constGlobal.domain1 = 'https://e.vxuey.com';
//关联教研老师最大数目
constGlobal.maxTeacherCount = 5;
//产品关联课程产品最大数目
constGlobal.maxRelationCount = 10;
//产品关联教务最大数目限制
constGlobal.maxRelationTeacherCount = 5;
//产品关联服务最大数目限制
constGlobal.maxProductServiceCount = 5;
//产品关联试卷最大数目限制
constGlobal.maxProductSheetCount = 5;
//产品关联练习题最大数目限制
constGlobal.maxProductExercisesCount = 5;
//产品关联课程最大数目限制--用于不同类型产品组件(团报、优惠券)
constGlobal.maxProductCoursesCount = 5;
//产品关联教材最大数目限制
constGlobal.maxTextbookCount = 10;
//大题数量上限
constGlobal.maxSubjectCount = 50;
//小题数量上限
constGlobal.minSubjectCount = 50;
//百度地址Apk
constGlobal.baiduMapApk = 'X7vzaovxIjrqYRoKc8xGuhgNxtz5mDSO';
//产品类型(请不要设置初始值)
constGlobal.productType = {
  video: { key: 1, value: "课程" },
  sheet: { key: 4, value: "试卷" },
  exercises: { key: 5, value: "练习题" }
}
//课程产品类型
constGlobal.courseCategory = [

  { key: 3, value: "直播课" },
  { key: 2, value: "网课" },
  { key: 1, value: "面授" }
]
// 请求数据
constGlobal.RequestTypeList = [

  { key: 1, value: "get" },
  { key: 2, value: "post" },
]
// 接口状态
constGlobal.status=[
  { key: '', value: "全部" },
  { key: '0', value: "请求成功" },
  { key: '1', value: "请求失败" },
]
//管理员类型
constGlobal.adminType = {
  admin: { key: 1, value: "管理员" },
  business: { key: 2, value: "业务员" },
  editor: { key: 3, value: "网络编辑" },
  educational: { key: 4, value: "教务" },
  marketing: { key: 5, value: "网络营销" },
  english: { key: 6, value: "英语老师" },
  adviser: { key: 7, value: "顾问老师" },
  groupLeader: { key: 8, value: "组长" },
  finance: { key: 9, value: "财务" },
}
//试题类型
constGlobal.subjectTypes = [
  { key: 1, value: "单选题" },
  { key: 2, value: "多选题" },
  { key: 3, value: "ֱ填空题" },
  { key: 4, value: "判断题" },
  { key: 5, value: "问答题" },
  { key: 6, value: "计算题" },
  { key: 7, value: "翻译题" },
  { key: 8, value: "ֱ作文题" },
  { key: 9, value: "完形填空" },
  { key: 10, value: "阅读理解" },
  { key: 11, value: "选词填空" },
]
//问卷类型
constGlobal.surveyTypes = [
  { key: 1, value: "单选题" },
  { key: 2, value: "多选题" },
  { key: 5, value: "问答题" },
]
//试题难度
constGlobal.difficultyLevels = [
  { key: 1, value: "一星" },
  { key: 2, value: "二星" },
  { key: 3, value: "ֱ三星" },
  { key: 4, value: "ֱ四星" },
  { key: 5, value: "ֱ五星" }
]
//学员属性--基础类型下拉框
constGlobal.studentCategory = [
  { key: 0, value: '全部' },
  { key: 1, value: '报名状态' },
  { key: 2, value: '来源渠道' },
  { key: 3, value: '报名意向' },
  { key: 4, value: '所属班级' },
  { key: 5, value: '预报课程' },
]
//学员反馈反馈类型下拉框
constGlobal.suggestIsReply = [
  { key: 0, value: '查所有' },
  { key: 1, value: '查已回复' },
  { key: 2, value: '查未回复' },
]
constGlobal.companyCertificatesTypeList = [
  { key: 2, value: "办学许可证编号" },
  { key: 1, value: "统一社会信用代码" }
]
constGlobal.agreementRecordStateList = [
  { key: 1, value: "待学员签订" },
  { key: 2, value: "已完成" },
  { key: 3, value: "审核中" },
  { key: 4, value: "拒绝审批" },
  { key: 5, value: "待签定作废" },
  { key: 6, value: "已签定作废" },
]
//排序类型
constGlobal.IsOrderList = [
  { key: 0, value: "全部" },
  { key: 1, value: "正序" },
  { key: 2, value: "倒序" }
]
constGlobal.questionState = [
  { key: 0, value: "不更新" },
  { key: 1, value: "待操作" },
  { key: 2, value: "对外不公开" },
  { key: 3, value: "对外公开" }
]
//优惠券券申领记录-优惠券状态
constGlobal.couponState = [
  { key: 0, value: '全部' },
  { key: 1, value: '未使用' },
  { key: 2, value: '已使用' },
  { key: 3, value: '转赠' },
  { key: 4, value: '已过期' },
]
//缺少获取管理员的接口临时使用
constGlobal.adminList = [
  { key: 0, value: '全部' },
  { key: 1, value: '测试1' },
  { key: 2, value: '测试2' },
  { key: 3, value: '测试3' },
  { key: 4, value: '测试4' },
]
//问题解决类型
constGlobal.isSolveList = [
  { key: 0, value: '全部' },
  { key: 1, value: '已解决' },
  { key: 2, value: '未解决' }
]
//当前状态
constGlobal.stateNownList = [
  { key: 0, value: '全部' },
  { key: 1, value: '待老师回复' },
  { key: 2, value: '待学员回复' },
  { key: 3, value: '已评价结单' },
]
//星级评价
constGlobal.starList = [
  { key: 0, value: '全部' },
  { key: 1, value: '一颗星' },
  { key: 2, value: '两颗星' },
  { key: 3, value: '三颗星' },
  { key: 4, value: '四颗星' },
  { key: 5, value: '五颗星' },
]
//性别类型
constGlobal.sexClass = [
  { key: 0, value: "全部" },
  { key: 1, value: "未设置" },
  { key: 2, value: "男" },
  { key: 3, value: "女" }
]
//英语基础类型
constGlobal.englishBasisClass = [
  { key: 1, value: "不确定" },
  { key: 2, value: "薄弱" },
  { key: 3, value: "中等" },
  { key: 4, value: "较好" }
]
//学员通知类型
constGlobal.studentNoticeCategory = [
  { key: 1, value: "系统通知" },
  { key: 2, value: "活动通知" },
  { key: 3, value: "支付通知" }
]
//学员消息阅读状态
constGlobal.studentNoticeType = [
  { key: 0, value: "全部" },
  { key: 1, value: "已读" },
  { key: 2, value: "未读" }
]
//考试状态--考试记录
constGlobal.examStates = [
  { key: -1, value: "全部" },
  { key: 1, value: "待考试" },
  { key: 2, value: "考试中" },
  { key: 3, value: "待评阅" },
  { key: 4, value: "待公布" },
  { key: 5, value: "待查阅" },
  { key: 6, value: "考试完成" },
  { key: 7, value: "考试逾期" }
]

//试题试卷练习题编号配置
constGlobal.SelectArray = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
constGlobal.Numbers = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26"];
constGlobal.MaxNumbers = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二", "十三", "十四", "十五", "十六", "十七", "十八", "十九", "二十", "二十一", "二十二", "二十三", "二十四", "二十五", "二十六"];
constGlobal.MaxNumbersLKM = ["①", "②", "③", "④", "⑤", "⑥", "⑦", "⑧", "⑨", "⑩", "⑪", "⑫", "⑬", "⑭", "⑮", "⑯", "⑰", "⑱", "⑲", "⑳", "㉑", "㉒", "㉓", "㉔", "㉕", "㉖"];//㉗㉘㉙㉚㉛㉜㉝㉞㉟㊱㊲㊳㊴㊵㊶㊷㊸㊹㊺㊻㊼㊽㊾㊿
constGlobal.subjectSelectMaxCount = 6;//试题选项组最大数目
constGlobal.studentMaxDoExerciseCount = 5;//学员最多练习次数
constGlobal.exerciseSubjectMaxCount = 50;//练习题最多可关联多少道试题
//格式化处理产品价格 integral为积分分值,originalPrice为原价,discountsPrice为优惠价
constGlobal.formatProductMonth = function (integral, originalPrice, discountsPrice,isRefund) {
  if(isRefund){
    if (integral > 0) return "<b>" + integral + "积分</b>购买";
    if (discountsPrice <= 0 && originalPrice > 0) discountsPrice = originalPrice;
    if (integral <= 0 && discountsPrice <= 0)
      return "<span>免费</span>";
    if (originalPrice > discountsPrice)
      return "原价:<b>" + originalPrice + "元</b>;优惠价:<b>" + discountsPrice + "元</b>";
    if (originalPrice == discountsPrice)
      return "<b>" + discountsPrice + "元</b>";
    return "<span>参数有误</span>";
  }else{
    if (integral > 0) return "<b>" + integral + "积分</b>购买";
    if (discountsPrice <= 0 && originalPrice > 0) discountsPrice = originalPrice;
    if (integral <= 0 && discountsPrice <= 0)
      return "<span style='color:red;'>免费</span>";
    if (originalPrice > discountsPrice)
      return "原价:<b>" + originalPrice + "元</b>;优惠价:<b>" + discountsPrice + "元</b>";
    if (originalPrice == discountsPrice)
      return "<b>" + discountsPrice + "元</b>";
    return "<span style='color:red;'>参数有误</span>";
  }
};
// 格式化处理,推广试卷练习类型
constGlobal.sheetExerciseTypeList = [
  {key:1,value:"PC端首页试卷"},
  {key:2,value:"PC端首页练习"},
  {key:3,value:"移动端首页练习题"},
  {key:4,value:"移动端首页试卷"},
 ]
// 移动端、小程序面板菜单跳转路径
// #前是移动端的跳转路径，#后是小程序的跳转路径
constGlobal.menuPathObj = [
  {name:"选课咨询",path:"/course#/pages/Course/Course"},
  {name:"资讯专栏",path:"/article/0#/pages/Article/Article"},
  {name:"学习乐园",path:"/"},
  {name:"真题模考",path:"/exam/0#/pages/Exam/Exam"},
  {name:"章节练习",path:"/exercise#/pages/Exercise/Exercise"},
  {name:"师资介绍",path:"/teacher#/pages/Teacher/Teacher"},
  {name:"我的学习",path:"/mylearning#/pages/Outer/wxStudentCenter/wxStudentCenter?redirectURL=/mylearning"},
  {name:"升本大使",path:"/sbanbassador/EarntuitionFees#/pages/Outer/wxStudentCenter/wxStudentCenter?redirectURL=/sbanbassador/Authentication"},
]
// pc端前台首页面板菜单
constGlobal.pcmenuPathObj = [
  {name:"首页",path:"/"},
  {name:"课程",path:"/course"},
  {name:"师资介绍",path:"/teacher"},
  {name:"资讯专栏",path:"/article"},
  {name:"真题模考",path:"/exam/0"},
  {name:"章节练习",path:"/exercise"},
 ]
constGlobal.isAdminType=[
  {bol:true,value:"管理员公众号"},
  {bol:false,value:"学员公众号"}
]
// 删除课程产品关联数据类别
// 使用于以下类别删除时，调用类别
constGlobal.delProductType=[
  {key:1,value:'面授课'},//暂未使用
  {key:2,value:'网课'},
  {key:3,value:'直播课'},
  {key:4,value:'试卷'},
  {key:5,value:'练习题'},
  {key:6,value:'资料讲义'},//暂未开发
  {key:7,value:'教材'},
  {key:8,value:'教师'},
  {key:9,value:'课程服务'},
]

export default {
  install (Vue) {
    Vue.prototype.$constGlobal = constGlobal;
  }
}
